export const Categories = {
    category_1: {
        key: 'medical-devices',
        title: 'Medical Devices',
    },
    category_2: {
        key: 'laparoscopy',
        title: 'Laparoscopy',
    },
    category_3: {
        key: 'hysteroscopy-set',
        title: 'Hysteroscopy Set',
    },
    category_4: {
        key: 'endo-urology',
        title: 'Endo Urology',
    },
    category_5: {
        key: 'ent',
        title: 'ENT',
    },
    category_6: {
        key: 'arthroscopy-set',
        title: 'Arthroscopy Set',
    },
    category_7: {
        key: 'general-surgery',
        title: 'General Surgery',
    },
    category_8: {
        key: 'orthopaedic-surgery',
        title: 'Orthopaedic Surgery',
    },
    category_9: {
        key: 'neurosurgery',
        title: 'Neurosurgery',
    },
    category_10: {
        key: 'spine-surgery',
        title: 'Spine Surgery',
    },
    category_11: {
        key: 'micro-surgery',
        title: 'Micro Surgery',
    },
    category_12: {
        key: 'dental-surgery',
        title: 'Dental Surgery',
    },
    category_13: {
        key: 'cardio-surgery',
        title: 'Cardio Surgery',
    },
    category_14: {
        key: 'urology',
        title: 'Urology',
    },
    category_15: {
        key: 'gestro-surgery',
        title: 'Gestro Surgery',
    },
    category_16: {
        key: 'pediatric-surgery',
        title: 'Pediatric Surgery',
    }
}

export const Services = {
    service_1: {
        key: 'private-labeling',
        title: 'Private Labeling'
    },
    service_2: {
        key: 'oem-solutions',
        title: 'OEM Solutions'
    },
    service_3: {
        key: 'custom-designing',
        title: 'Custom Designing'
    }
}

export const Csr = {
    csr_1: {
        key: 'jupiter-smile-foundation',
        title: 'Jupiter Smile Foundation'
    }

}

export const Category_1_Products = {
    parentKey: `${Categories.category_1.key}`,
    product_1: {
        key: 'endovision-hd-camera-system',
        title: 'Endovision HD Camera System'
    },
    product_2: {
        key: 'co2-insufflators',
        title: 'CO2 Insufflators'
    },
    product_3: {
        key: 'led-light-source-touch-screen',
        title: 'LED Light Source Touch Screen'
    },
    product_4: {
        key: 'fiber-optic-light-cable',
        title: 'Fiber Optic Light Cable'
    },
    product_5: {
        key: 'suction-&-irrigation-pump',
        title: 'Suction & Irrigation Pump'
    },
    product_6: {
        key: 'automatic-tourniquet',
        title: 'Automatic Tourniquet'
    },
    product_7: {
        key: 'autopsy-saw',
        title: 'Autopsy Saw'
    },
    product_8: {
        key: 'plaster-cutter-with-suction',
        title: 'Plaster Cutter with Suction'
    },
    product_9: {
        key: 'operating-stool',
        title: 'Operating Stool'
    },
    product_10: {
        key: 'loupes',
        title: 'Loupes'
    },
    product_11: {
        key: 'portable-light-and-battery-backup',
        title: 'Portable Light and Battery Backup'
    },
    product_12: {
        key: 'vacuum-suction',
        title: 'Vacuum Suction'
    }
}

export const Category_2_Products = {
    parentKey: `${Categories.category_2.key}`,
    product_1: {
        key: 'laparoscopy-hand-instruments',
        title: 'Laparoscopy Hand Instruments'
    },
    product_2: {
        key: 'telescopes',
        title: 'Telescopes'
    },
    product_3: {
        key: 'trocars-and-accessories',
        title: 'Trocars And Accessories'
    },
    product_4: {
        key: 'instruments-for-gynecology',
        title: 'Instruments For Gynecology'
    },
    product_5: {
        key: 'single-puncture-laparoscope',
        title: 'Single Puncture Laparoscope'
    },
    product_6: {
        key: 'suction-and-irrigation-cannula',
        title: 'Suction And Irrigation Cannula'
    },
    product_7: {
        key: 'hemolock-clip-applicator',
        title: 'Hemolock Clip Applicator'
    },
    product_8: {
        key: 'nathanson-retractor',
        title: 'Nathanson Retractor'
    },
    product_9: {
        key: 'needle-holder',
        title: 'Needle Holder'
    },
}

export const Category_3_Products = {
    parentKey: `${Categories.category_3.key}`,
    product_1: {
        key: 'hysteroscope-telescope',
        title: 'Hysteroscope Telescope'
    },
    product_2: {
        key: 'hysteroscopy-sheath',
        title: 'Hysteroscopy Sheath'
    },
    product_3: {
        key: 'flexible-and-semi-rigid-forceps',
        title: 'Flexible and Semi Rigid Forceps'
    },
    product_4: {
        key: 'hysteroscopy-and-irrigation-pump',
        title: 'Hysteroscopy and Irrigation Pump'
    },
    product_5: {
        key: 'monopolar-and-bipolar-cautery-electrode',
        title: 'Monopolar and Bipolar Cautery Electrode'
    },
    product_6: {
        key: 'resectoscope',
        title: 'Resectoscope'
    },
    product_7: {
        key: 'office-hysteroscope',
        title: 'Office Hysteroscope'
    }
}


export const Category_4_Products = {
    parentKey: `${Categories.category_4.key}`,
    product_1: {
        key: 'cystoscopy-resectoscopes-telescopes',
        title: 'Cystoscopy Resectoscopes Telescopes'
    },
    product_2: {
        key: 'cystoscopy-sheath',
        title: 'Cystoscopy Sheath'
    },
    product_3: {
        key: 'resectoscopy-sheath',
        title: 'Resectoscopy Sheath'
    },
    product_4: {
        key: 'working-elements',
        title: 'Working Elements'
    },
    product_5: {
        key: 'visual-obturator',
        title: 'Visual Obturator'
    },
    product_6: {
        key: 'urethrotome-sheath',
        title: 'Urethrotome Sheath'
    },
    product_7: {
        key: 'nephroscope',
        title: 'Nephroscope'
    },
    product_8: {
        key: 'ureterorenoscope',
        title: 'Ureterorenoscope'
    },
    product_9: {
        key: 'laser-resectoscope-set',
        title: 'Laser Resectoscope Set'
    },
    product_10: {
        key: 'pneumatic-lithotripter',
        title: 'Pneumatic Lithotripter'
    },
    product_11: {
        key: 'stone-punch-set',
        title: 'Stone Punch Set'
    }
}

export const Category_5_Products = {
    parentKey: `${Categories.category_5.key}`,
    product_1: {
        key: 'sinuscope-and-endoscopes',
        title: 'Sinuscope and Endoscopes'
    },
    product_2: {
        key: 'fess-set',
        title: 'FESS Set'
    },
    product_3: {
        key: 'led-head-light',
        title: 'LED Head Light'
    },
    product_4: {
        key: 'septoplasty',
        title: 'Septoplasty'
    },
    product_5: {
        key: 'tympanoplasty',
        title: 'Tympanoplasty'
    },
    product_6: {
        key: 'bronchoscopy-set-rigid',
        title: 'Bronchoscopy Set Rigid'
    },
    product_7: {
        key: 'ent-general-surgery-instruments',
        title: 'ENT General Surgery Instruments'
    }
}

export const Category_6_Products = {
    parentKey: `${Categories.category_6.key}`,
    product_1: {
        key: 'arthroscope',
        title: 'Arthroscope'
    },
    product_2: {
        key: 'arthrosopy-pump',
        title: 'Arthrosopy Pump'
    },
    product_3: {
        key: 'arthroscopy-sheath',
        title: 'Arthroscopy Sheath'
    },
    product_4: {
        key: 'hook-probe',
        title: 'Hook Probe'
    },
    product_5: {
        key: 'arthroscopy-punch',
        title: 'Arthroscopy Punch'
    },
    product_6: {
        key: 'arthroscopy-grasper',
        title: 'Arthroscopy Grasper'
    },
    product_7: {
        key: 'automatic-tourniquet-single-dual',
        title: 'Automatic Tourniquet Single Dual'
    }
}

export const Category_7_Products = {
    parentKey: `${Categories.category_7.key}`,
    product_1: {
        key: 'retractors',
        title: 'Retractors'
    },
    product_2: {
        key: 'elevator-probes-currettes',
        title: 'Elevator Probes Currettes'
    },
    product_3: {
        key: 'clamps',
        title: 'Clamps'
    },
    product_4: {
        key: 'forceps',
        title: 'Forceps'
    },
    product_5: {
        key: 'scissors',
        title: 'Scissors'
    },
    product_6: {
        key: 'needle-holders',
        title: 'Needle Holders'
    },
    product_7: {
        key: 'suction-tubes',
        title: 'Suction Tubes'
    }
}

export const Category_8_Products = {
    parentKey: `${Categories.category_8.key}`,
    product_1: {
        key: 'bone-holding-forceps',
        title: 'Bone Holding Forceps'
    },
    product_2: {
        key: 'retractors-orthopaedic',
        title: 'Retractors Orthopaedic'
    },
    product_3: {
        key: 'bone-nibbler-and-cutters',
        title: 'Bone Nibbler and Cutters'
    },
    product_4: {
        key: 'bone-punch',
        title: 'Bone Punch'
    },
    product_5: {
        key: 'screw-drivers',
        title: 'Screw Drivers'
    },
    product_6: {
        key: 'osteotomes-chisels-gouges',
        title: 'Osteotomes Chisels Gouges'
    },
    product_7: {
        key: 'drill-and-reamers',
        title: 'Drill and Reamers'
    },
    product_8: {
        key: 'pin-wire-and-rod-cutter',
        title: 'Pin Wire and Rod Cutter'
    },
    product_9: {
        key: 'elevators-and-currettes',
        title: 'Elevators And Currettes'
    },
    product_10: {
        key: 'hammer',
        title: 'Hammer'
    },
    product_11: {
        key: 'orthopedic-instrument-sets',
        title: 'Orthopedic Instrument Sets'
    }
}

export const Category_9_Products = {
    parentKey: `${Categories.category_9.key}`,
    product_1: {
        key: 'suction-and-irrigation-cannulas',
        title: 'Suction and Irrigation Cannulas'
    },
    product_2: {
        key: 'gigli-wire',
        title: 'Gigli Wire'
    },
    product_3: {
        key: 'hudson-brace',
        title: 'Hudson Brace'
    },
    product_4: {
        key: 'rongeurs-punches',
        title: 'Rongeurs Punches'
    },
    product_5: {
        key: 'retractors-neuro',
        title: 'Retractors Neuro'
    },
    product_6: {
        key: 'elevators-and-dissectors',
        title: 'Elevators and Dissectors'
    },
    product_7: {
        key: 'bone-cutter-and-nibblers',
        title: 'Bone Cutter and Nibblers'
    },
    product_8: {
        key: 'forceps-and-scissors',
        title: 'Forceps and Scissors'
    }
}

export const Category_10_Products = {
    parentKey: `${Categories.category_10.key}`,
    product_1: {
        key: 'laminectomy-punches',
        title: 'Laminectomy Punches'
    },
    product_2: {
        key: 'disc-rongeur',
        title: 'Disc Rongeur'
    },
    product_3: {
        key: 'bone-cutter-and-nibbler',
        title: 'Bone Cutter and Nibbler'
    },
    product_4: {
        key: 'osteotomes-chisels-and-gouges',
        title: 'Osteotomes Chisels and Gouges'
    },
    product_5: {
        key: 'mallets',
        title: 'Mallets'
    },
    product_6: {
        key: 'bone-graft-impactor',
        title: 'Bone Graft Impactor'
    },
    product_7: {
        key: 'elevator-and-dissector',
        title: 'Elevator and Dissector'
    },
    product_8: {
        key: 'retractors-spine',
        title: 'Retractors Spine'
    },
    product_9: {
        key: 'currettes-hook-probe',
        title: 'Currettes Hook Probe'
    }
}

export const Category_11_Products = {
    parentKey: `${Categories.category_11.key}`,
    product_1: {
        key: 'micro-needle-holders-and-scissors',
        title: 'Micro Needle Holders and Scissors'
    },
    product_2: {
        key: 'cannulas-mircro-surgery',
        title: 'Cannulas Mircro Surgery'
    },
    product_3: {
        key: 'retractors-mircro-surgery',
        title: 'Retractors Mircro Surgery'
    },
    product_4: {
        key: 'micro-forceps',
        title: 'Micro Forceps'
    },
    product_5: {
        key: 'osteotome-chisel-and-gouge',
        title: 'Osteotome Chisel and Gouge'
    },
    product_6: {
        key: 'mallet-gouge',
        title: 'Mallet Gouge'
    }
}

export const Category_12_Products = {
    parentKey: `${Categories.category_12.key}`,
    product_1: {
        key: 'extraction-set',
        title: 'Extraction Set'
    },
    product_2: {
        key: 'maxillofacial-instruments-set',
        title: 'Maxillofacial Instruments Set'
    },
    product_3: {
        key: 'general-dentistry',
        title: 'General Dentistry'
    },
    product_4: {
        key: 'cranio-mayillofacial-sets',
        title: 'Cranio-Mayillofacial Sets'
    }
}

export const Category_13_Products = {
    parentKey: `${Categories.category_13.key}`,
    product_1: {
        key: 'test',
        title: 'Test'
    }
}

export const Category_14_Products = {
    parentKey: `${Categories.category_14.key}`,
    product_1: {
        key: 'test',
        title: 'Test'
    }
}

export const Category_15_Products = {
    parentKey: `${Categories.category_15.key}`,
    product_1: {
        key: 'test',
        title: 'Test'
    }
}

export const Category_16_Products = {
    parentKey: `${Categories.category_16.key}`,
    product_1: {
        key: 'test',
        title: 'Test'
    }
}